import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import HomePage2 from '../HomePage2/HomePage2';
import AboutPage from '../AboutPage/AboutPage';
import ShopPage from '../ShopPage'
import ProductSinglePage from '../ProductSinglePage';
import ContactPage from '../ContactPage/ContactPage';
import PrivacePage from '../PrivacePage/PrivacePage';
import TermsPage from '../TermsPage/TermsPage';
import ErrorPage from '../ErrorPage/ErrorPage';


import BilgiFormlariPage from '../BilgiFormlariPage';

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage2 />} />
          <Route path="about" element={<AboutPage />} />
          <Route path="shop" element={<ShopPage />} />
          <Route path='shop-single/:slug' element={<ProductSinglePage />} />
          <Route path='contact' element={<ContactPage />} />
          <Route path="privace" element={<PrivacePage />} />
          <Route path="terms" element={<TermsPage />} />
          <Route path="bilgi-formlari" element={<BilgiFormlariPage />} />
          <Route path='404' element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
